import { Option } from "widgets-for-react";
import { Link } from "../../../cms/blocks/types.gen";
import { CustomPagesState } from "../types.mod";


export type Fc150YearsPages = 'homepage' | 'stories-overview-page' | 'story-detail-page' | 'transition-page' | '404'
interface Taxonomy {
  kind: string
  label: string
  icon: string
  color: string
}

interface BuildingBlock {
  taxonomy: Taxonomy
  text: string
  images: string[]
  link: Link
}

export interface LoaderPage {
  title: string
  intro: string
  building_blocks: BuildingBlock[]
}

export interface HomeState {
  kind: 'home'
  splashState: 'no-show' | 'show' | 'expanding' | 'wave-up'
}

export const zeroHomeState = (): HomeState => ({
  kind: 'home',
  splashState: 'show',
})

export interface StoriesLoader {
  title: string
  intro: string
  image: string
  url: string
}

export interface StoriesOverviewState {
  kind: 'stories-overview'
  title: string
  isAbout: boolean
}

export const zeroStoriesOverviewState = (): StoriesOverviewState => ({
  kind: 'stories-overview',
  title: '',
  isAbout: false,
})

export interface StoryDetailState {
  kind: 'story-detail'
  overview_title: string
  title: string
}

export const zeroStoryDetailState = (): StoryDetailState => ({
  kind: 'story-detail',
  overview_title: '',
  title: ""
})


export type AnimationState = 'about-to-move-up' | 'wave-moving-up' | 'wave-up' | 'wave-moving-down' | 'about-to-move-down'

export type TransitionObject = Pick<CustomPagesState["Fc150YearsMainPage"], "homeState" | "storiesOverviewState" | "storyDetailState" | "current_page" | "state">
export interface TransitionState {
  kind: 'transition'
  from: Option<TransitionObject>
  to: TransitionObject
  animationState: AnimationState
  animationTime: number
}

export interface SimplePage<T> {
  entity: T 
  total_pages: number
  taxonomy: number 
  page: number
}